import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const SELECT_PAYMENT_METHOD = 'PAYMENT_WIDGET :: PAYMENT_METHODS :: SELECT';

export type TSelectPaymentMethodAction = ITypedReduxAction<typeof SELECT_PAYMENT_METHOD, string>;

export const selectPaymentMethod: (payload: string) => TSelectPaymentMethodAction = actionGenerator<
  typeof SELECT_PAYMENT_METHOD,
  string
>(SELECT_PAYMENT_METHOD);
